import React, {useCallback, useEffect, useState} from 'react';
import {apiService} from '@/core/api';
import {API_ENDPOINTS} from '@/core/constants/endpoints';
import {BillingInfoResponse, PaymentMethod} from '@/features/settings/service/userService';
import './BillingTab.scss';

export const BillingTab: React.FC = () => {
  const [billingInfo, setBillingInfo] = useState<BillingInfoResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchBillingInfo = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.get<BillingInfoResponse>(API_ENDPOINTS.BILLING.BILLING_INFO);
      setBillingInfo(response);
      // console.log('Billing info:', response);
    } catch (error) {
      console.error('Failed to fetch billing info:', error);
      setError('Failed to load billing information');
      setBillingInfo(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBillingInfo();
  }, [fetchBillingInfo]);

  // const getDefaultPaymentMethod = (): PaymentMethod | undefined => {
  //   if (!billingInfo?.data.payment_methods || !billingInfo?.data.default_payment_method) {
  //     return undefined;
  //   }
  //   return billingInfo.data.payment_methods.find((pm) => pm.id === billingInfo.data.default_payment_method);
  // };

  // const formatCardBrand = (brand: string): string => {
  //   return brand.charAt(0).toUpperCase() + brand.slice(1);
  // };

  return (
    <div className="settings-content">
      <h2>Billing Information</h2>
      <p>Manage your payment methods and billing details.</p>

      {loading && <p>Loading billing information...</p>}
      {!loading && !error && billingInfo && (
        <div className="billing-section">
          <a href={`${billingInfo.portal_url}`} className="billinLink">
            Access your billing info{' '}
          </a>
        </div>
      )}
      {error && (
        <div className="billing-error">
          <p>{error}</p>
          <button onClick={fetchBillingInfo}>Retry</button>
        </div>
      )}

      {/* {!loading && !error && billingInfo && ( */}
      {/* <div className="billing-details">

          <div className="billing-section">
            <h3>Customer Information</h3>
            <div className="customer-info">
              To access your billing info click <a href={`${billingInfo.portal_url}`}>here</a>
            </div>
          </div> */}

      {/* Billing Address */}
      {/* <div className="billing-section">
            <h3>Billing Address</h3>
            <div className="address-info">
              <div className="info-row">
                <label>Street:</label>
                <span>{billingInfo.data.customer.address.line1}</span>
              </div>
              <div className="info-row">
                <label>City:</label>
                <span>{billingInfo.data.customer.address.city}</span>
              </div>
              <div className="info-row">
                <label>Postal Code:</label>
                <span>{billingInfo.data.customer.address.postal_code}</span>
              </div>
              <div className="info-row">
                <label>Country:</label>
                <span>{billingInfo.data.customer.address.country}</span>
              </div>
            </div>
          </div> */}

      {/* Payment Methods */}
      {/* <div className="billing-section">
            <h3>Payment Methods</h3>
            {billingInfo.data.payment_methods.length > 0 ? (
              <div className="payment-methods">
                {billingInfo.data.payment_methods.map((method) => {
                  const isDefault = method.id === billingInfo.data.default_payment_method;
                  return (
                    <div key={method.id} className={`payment-method ${isDefault ? 'default' : ''}`}>
                      <div className="payment-method-info">
                        <div className="card-brand">{formatCardBrand(method.brand)}</div>
                        <div className="card-details">
                          **** **** **** {method.last4}
                        </div>
                        <div className="card-expiry">
                          Expires {method.exp_month.toString().padStart(2, '0')}/{method.exp_year}
                        </div>
                        {isDefault && <span className="default-badge">Default</span>}
                      </div>
                      <div className="payment-method-id">ID: {method.id}</div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p>No payment methods found</p>
            )}
          </div> */}
      {/* </div>
      )} */}

      {/* {!loading && !error && !billingInfo && (
         <div className="no-billing-info">
           <p>No billing information available</p>
         </div>
       )} */}
    </div>
  );
};
